import { Input, PasswordInput } from "@mantine/core";
 
function InputGroup({ placeholder, icon, type = "text", ...props }) {
  const Component = type === "password" ? PasswordInput : Input;
 
  return (
    <Component
      icon={icon}
      placeholder={placeholder}
      radius="md"
      size="md"
      classNames={{
        input: `
          bg-white border-black
          focus:border-yellow-400 focus:ring-1 focus:ring-yellow-400
          hover:border-yellow-400
        `,
      }}
      {...props}
    />
  );
}
 
export default InputGroup;